var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCartLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17.0267L1.80354 16.1071L25.9828 9.92493L24.0317 24.8844L4.46005 27.9618L2.19284 27.2907L0 17.0267Z",
    fill: "#ffcc00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.083 12.0311L24.8848 4.09663L30.8358 0H34.0001L27.353 4.8674L24.2143 12.6312L22.083 12.0311Z",
    fill: "#ffcc00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80788 31.7652L5.07119 32L3.49658 29.7804L4.65982 27.3273L7.39651 27.0936L8.97112 29.312L7.80788 31.7652Z",
    fill: "#ffcc00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1033 29.3121L20.3666 29.5468L18.792 27.3273L19.9541 24.8741L22.6919 24.6405L24.2654 26.8589L23.1033 29.3121Z",
    fill: "#ffcc00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25403 16.5079L4.19189 16.7851L5.05299 23.0337L5.0925 26.1087L6.23366 26.6585L6.02449 21.822L5.25403 16.5079Z",
    fill: "#EC812D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6432 13.4775L21.5415 13.5096L20.9628 19.7754L20.3027 22.7714L21.294 23.5616L22.1888 18.8145L22.6432 13.4775Z",
    fill: "#EC812D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3079 15.3363L9.20044 15.6295L9.02148 21.0775L9.34454 25.5567L10.2986 25.1398L10.1069 19.0813L10.3079 15.3363Z",
    fill: "#EC812D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0995 13.8669L17.0059 14.1601L16.8188 19.5704L17.128 24.0163L18.0704 23.6006L17.8926 17.5868L18.0995 13.8669Z",
    fill: "#EC812D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9907 15.0775L13.8007 24.3554L14.556 25.0036L14.0041 15.3902L12.9907 15.0775Z",
    fill: "#EC812D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.976 15.3363L3.80471 19.6792L2.44043 20.7912L23.3589 16.6236L23.976 15.3363Z",
    fill: "#EC812D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9123 19.3722L3.84445 24.1571L2.50342 25.291L23.322 20.6618L23.9123 19.3722Z",
    fill: "#EC812D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartLight);
export default __webpack_public_path__ + "static/media/icon-cart-light.26eab4392cd383fcab1b927a12feba16.svg";
export { ForwardRef as ReactComponent };